export default __webpack_public_path__ + "static/outsource@2x-ca7eb214a274474348c75f3313710a0f.webp";